import type { ToolCallRecord, ToolCallType } from "@yagni/shared";

export interface ToolCallDisplay {
  id: string;
  tool: string;
  type: ToolCallType;
  params: Record<string, unknown>;
  result: Record<string, unknown> | null;
  calledAt: string | null;
  completedAt: string | null;
  status: "running" | "completed" | "failed";
}

export function isToolCallError(
  result: Record<string, unknown> | null,
): boolean {
  if (!result) return false;
  if (result.success === false) return true;
  if (typeof result.error === "string") return true;
  if (typeof result.errorCode === "string") return true;
  return false;
}

export function toToolCallDisplay(record: ToolCallRecord): ToolCallDisplay {
  let status: ToolCallDisplay["status"];
  if (!record.completedAt) {
    status = "running";
  } else if (isToolCallError(record.result)) {
    status = "failed";
  } else {
    status = "completed";
  }
  return { ...record, status };
}
